<script lang="ts">
  import type { DataHandler } from '@vincjo/datatables/remote';

  export let handler: DataHandler;
  export let options: number[] = [10, 50, 100, 200, 500];
  export let store: any;

  const rowsPerPage = handler.getRowsPerPage();
  const setRowsPerPage = () => {
    handler.setPage(1);
    store.updatePageSize($rowsPerPage);
    handler.invalidate();
  };
</script>

<aside class="flex place-items-center rounded-md border border-surface-600">
  <select class="select text-slate-600" bind:value={$rowsPerPage} on:change={setRowsPerPage}>
    {#each options as option}
      <option class="text-slate-600" value={option}>
        {option} Entries
      </option>
    {/each}
  </select>
</aside>
